<div id="landing-header-container" class="text-center mb-3">
  <a routerLink="courses" title="Course catalog">
    <img src="https://learn.cdn.abmp.com/public/ng/landingheader2.svg" class="w-100 mb-3" width="1110" height="304" />
  </a>
</div>
